export const WELCOME_TRANSLATIONS = {
  "fr": {
    "welcome.intro": "Bienvenue sur Eternua",
    "welcome.beta": "Bêta",
    "welcome.headline": "Toute mise en relation commence par une connexion humaine.",
    "welcome.mission": "Réunir les personnes, les idées et les projets dans un même univers. Explorer aujourd’hui, construire des liens et imaginer la suite ensemble.",
    "welcome.explore": "Explorer les univers",
    "welcome.login": "Se connecter",
    "welcome.trust": "Site en bêta · LIA maintenant · Aelith ensuite",
    "welcome.doors": "Dix portes d’entrée",
    "welcome.universes": "Explorez les univers Eternua",
    "welcome.universesLead": "Dix entrées pour découvrir le quotidien, les projets et la communauté. La Marketplace regroupe les rubriques spécialisées ; Forum, Amis et Récompenses ont leur propre espace. Le site reste en bêta, avec des possibilités et des conditions propres à chaque rubrique.",
    "welcome.market": "Voir toutes les rubriques de la Marketplace →",
    "welcome.today": "Votre premier pas · Aujourd’hui",
    "welcome.lia": "LIA vous accueille",
    "welcome.liaLead": "Bienvenue. Décrivez ce que vous cherchez : LIA vous guide vers les rubriques utiles et vous aide à choisir votre prochain pas.",
    "welcome.liaNote": "LIA vous accompagne ici avec des réponses préparées et des parcours guidés, sans IA conversationnelle.",
    "welcome.future": "La continuité · Vision future",
    "welcome.aelith": "De LIA à Aelith",
    "welcome.aelithLead": "LIA vous accueille aujourd’hui sur le site. Aelith est le futur robot humanoïde imaginé pour prolonger cet accompagnement dans le monde physique.",
    "welcome.now": "Aujourd’hui",
    "welcome.liaDigital": "LIA, le guide numérique",
    "welcome.liaDigitalLead": "Un accueil sur écran, des suggestions et des liens pour explorer Eternua.",
    "welcome.tomorrow": "Demain · Projet à concevoir",
    "welcome.aelithRobot": "Aelith, le robot humanoïde",
    "welcome.aelithRobotLead": "Une présence physique envisagée pour accueillir et orienter. Sa forme et ses capacités restent à concevoir et à valider.",
    "welcome.aelithNote": "Aelith n’est pas disponible aujourd’hui. La vision 2035–3024 exprime un horizon, sans date de lancement annoncée.",
    "welcome.humanAi": "Découvrir les quarante-quatre IA humaines",
    "welcome.guide": "Premiers pas et conseils de confiance",
    "welcome.prelaunch": "Le pré-lancement : ce qui est disponible et la suite du projet",
    "welcome.choice": "À vous de choisir",
    "welcome.next": "Votre prochain pas sur Eternua",
    "welcome.nextLead": "Découvrez les usages actuels, laissez LIA vous guider ou explorez ce que nous imaginons pour demain.",
    "welcome.start": "Commencer sur Eternua",
    "welcome.discover": "Découvrir Eternua",
    "welcome.talk": "Parler avec LIA",
    "welcome.seeUniverses": "Voir les univers",
    "welcome.discoverAelith": "Découvrir le futur Aelith",
    "welcome.eternuaBeta": "Eternua en bêta",
    "welcome.catalog.1": "Acheter",
    "welcome.catalog.2": "Vendre",
    "welcome.catalog.3": "Emploi",
    "welcome.catalog.4": "Services",
    "welcome.catalog.5": "Sorties",
    "welcome.catalog.6": "Voyages",
    "welcome.catalog.7": "Crowdfunding",
    "welcome.catalog.8": "Récompenses",
    "welcome.catalog.9": "Forum",
    "welcome.catalog.10": "Amis",
    "welcome.catalog.11": "Trouver un objet et découvrir les annonces.",
    "welcome.catalog.12": "Donner une nouvelle vie à ce que vous proposez.",
    "welcome.catalog.13": "Relier les talents aux opportunités.",
    "welcome.catalog.14": "Découvrir des savoir-faire et proposer les vôtres.",
    "welcome.catalog.15": "Partager des activités et des moments ensemble.",
    "welcome.catalog.16": "Explorer des destinations et préparer un départ.",
    "welcome.catalog.17": "Découvrir des projets dans un espace de démonstration.",
    "welcome.catalog.18": "Découvrir les avantages et leurs conditions.",
    "welcome.catalog.19": "Faire circuler les idées et participer aux discussions.",
    "welcome.catalog.20": "Retrouver vos liens et partager votre quotidien.",
    "welcome.catalog.21": "Connexion requise",
    "welcome.catalog.22": "Démo · financement indisponible",
    "welcome.catalog.23": "Lecture publique · connexion pour participer",
    "gettingStarted.eyebrow": "Votre guide · Avant de vous inscrire",
    "gettingStarted.title": "Premiers pas sur Eternua",
    "gettingStarted.mission": "Lutter contre l’isolement, faciliter les rencontres et faire grandir la confiance : Eternua rend le premier contact plus simple. Un objet à donner, un service à proposer ou une activité à partager peut devenir le début d’un lien humain.",
    "gettingStarted.intro": "Explorez à votre rythme, sans compte. Ces cinq repères vous aident à découvrir Eternua et à comprendre la suite, lorsque vous souhaiterez participer. Vous savez déjà quoi faire ? Accédez directement à l’action de votre choix.",
    "gettingStarted.noAccount": "Sans compte",
    "gettingStarted.discover": "Découvrir Eternua",
    "gettingStarted.discoverLead": "Comprenez la mission, repérez les rubriques qui vous intéressent et explorez les possibilités du quotidien. LIA peut vous aider à vous orienter.",
    "gettingStarted.understand": "Comprendre la mission",
    "gettingStarted.pace": "À votre rythme",
    "gettingStarted.choose": "Choisir ce que je veux faire",
    "gettingStarted.chooseLead": "Ouvrez la rubrique adaptée à ce que vous voulez faire.",
    "gettingStarted.chooseAria": "Choisir une action sur Eternua",
    "gettingStarted.buy": "Acheter",
    "gettingStarted.sell": "Vendre",
    "gettingStarted.give": "Donner",
    "gettingStarted.service": "Proposer un service",
    "gettingStarted.conditions": "Certaines actions nécessitent une connexion. Les conditions sont indiquées dans chaque rubrique.",
    "gettingStarted.ready": "Quand vous êtes prêt",
    "gettingStarted.profile": "Créer mon profil de confiance",
    "gettingStarted.profileLead": "Rejoignez la communauté lorsque vous souhaitez participer. Après inscription, le parcours d’accueil vous accompagne pour confirmer votre e-mail, vous présenter, choisir vos objectifs et régler vos préférences.",
    "gettingStarted.profileHint": "La confiance se construit avec des informations sincères et les vérifications disponibles. Un profil ne garantit pas le comportement d’une personne.",
    "gettingStarted.create": "Créer mon compte",
    "gettingStarted.login": "Déjà un compte ? Se connecter",
    "gettingStarted.before": "Avant vos premiers échanges",
    "gettingStarted.safe": "Interagir en sécurité",
    "gettingStarted.safeLead": "Prenez le temps de lire les profils, clarifiez vos attentes et respectez les limites de chacun. Gardez vos codes de connexion privés. Si un échange vous met mal à l’aise, consultez les moyens d’aide et de signalement proposés par Eternua.",
    "gettingStarted.trust": "Consulter le centre de confiance",
    "gettingStarted.after": "Après connexion",
    "gettingStarted.activity": "Suivre mon activité",
    "gettingStarted.activityLead": "Retrouvez votre espace personnel dans Mes Eternua. Accédez à vos contenus et suivez vos démarches dans les espaces prévus, selon les actions que vous avez réalisées.",
    "gettingStarted.required": "Connexion requise pour accéder à votre activité personnelle.",
    "gettingStarted.open": "Ouvrir Mes Eternua",
    "gettingStarted.activityAria": "Retrouver mon activité après connexion",
    "gettingStarted.content": "Mes contenus",
    "gettingStarted.steps": "Mes démarches",
    "gettingStarted.help": "Besoin d’aide ? LIA vous guide",
    "gettingStarted.universes": "Voir tous les univers",
    "prelaunch.eyebrow": "Pré-lancement · Eternua en bêta",
    "prelaunch.titleStart": "Les premiers liens commencent",
    "prelaunch.titleEnd": "avec vous.",
    "prelaunch.mission": "Rapprocher les personnes pour s’entraider, partager et faire grandir des projets ensemble.",
    "prelaunch.invitation": "Rejoignez Eternua avant son ouverture complète et prenez part aux premiers échanges.",
    "prelaunch.create": "Créer mon compte",
    "prelaunch.discover": "Découvrir le projet",
    "prelaunch.public": "Vous pouvez aussi explorer les espaces publics sans compte.",
    "prelaunch.community": "La communauté fondatrice",
    "prelaunch.communityTitle": "Un projet prend vie quand on s’y retrouve.",
    "prelaunch.communityLead": "Les premiers membres donnent le ton : un accueil, une idée, un échange. Votre présence compte dès les premiers pas.",
    "prelaunch.why": "Pourquoi rejoindre maintenant ?",
    "prelaunch.whyLead": "Prenez vos repères, découvrez les univers qui vous ressemblent et lancez les premières conversations dans le forum.",
    "prelaunch.uses": "Ce que vous pourrez faire sur Eternua",
    "prelaunch.usesLead": "Un aperçu des usages, selon l’ouverture et les conditions de chaque rubrique.",
    "prelaunch.find": "Trouver et proposer",
    "prelaunch.findLead": "Des objets, des services et des opportunités près de vos besoins.",
    "prelaunch.meet": "Rencontrer et partager",
    "prelaunch.meetLead": "Des discussions, des idées de sorties et de nouveaux liens.",
    "prelaunch.grow": "Faire grandir des idées",
    "prelaunch.growLead": "Découvrir des projets et échanger avec d’autres membres.",
    "prelaunch.before": "Avant de nous rejoindre",
    "prelaunch.answers": "Quelques réponses, simplement.",
    "prelaunch.available": "Est-ce que tout est déjà disponible ?",
    "prelaunch.availableAnswer": "Pas encore. Eternua est en bêta : certains espaces sont accessibles, d’autres restent en démonstration ou en préparation. Leur statut et leurs conditions sont indiqués dans chaque rubrique. Aucune date d’ouverture complète n’est annoncée.",
    "prelaunch.beforeAccount": "Puis-je découvrir Eternua avant de m’inscrire ?",
    "prelaunch.beforeAccountAnswer": "Oui. Vous pouvez découvrir le projet et parcourir les espaces publics sans compte. Le bouton « Créer mon compte » vous conduit au parcours d’inscription ; certaines actions demandent ensuite une connexion.",
    "prelaunch.founding": "Que signifie « communauté fondatrice » ?",
    "prelaunch.foundingAnswer": "Ce sont les personnes qui rejoignent Eternua à ses débuts et font vivre ses premiers échanges. Cette expression ne désigne ni une offre payante, ni un statut spécial, ni des avantages garantis.",
    "login.brand": "LA CONVERGENCE DE L’INFINI",
    "login.chapter": "VOTRE UNIVERS VOUS ATTEND",
    "login.headlineStart": "Retrouvez ce qui",
    "login.headlineMiddle": "vous",
    "login.headlineEnd": "relie.",
    "login.lead": "Les conversations qui comptent. Les projets qui vous ressemblent. Tout votre univers, à nouveau à portée de main.",
    "login.storyBottom": "Des liens. Des idées. Des possibles.",
    "login.personal": "Votre espace personnel",
    "login.welcome": "Bienvenue chez vous",
    "login.intro": "Vos liens, vos projets et vos envies vous attendent.",
    "login.mfaRequired": "Google Authenticator requis",
    "login.mfaIntro": "Entre le code à 6 chiffres pour finaliser la connexion",
    "login.username": "E-mail ou nom d’utilisateur",
    "login.usernamePlaceholder": "vous@exemple.fr ou votre identifiant",
    "login.password": "Mot de passe",
    "login.passwordPlaceholder": "Votre mot de passe",
    "login.remember": "Se souvenir de cet appareil",
    "login.forgot": "Mot de passe oublié ?",
    "login.mfaCode": "Code Google Authenticator",
    "login.mfaHelp": "Saisis uniquement les six chiffres de l’application.",
    "login.trustDevice": "Faire confiance à cet appareil pendant 30 jours",
    "login.back": "Retour à l’identifiant et au mot de passe",
    "login.new": "Nouveau sur Eternua ?",
    "login.create": "Créer mon compte gratuitement",
    "login.private": "Vos informations restent privées et protégées.",
    "login.footer": "Un espace pour ce qui compte.",
    "login.footerNav": "Informations",
    "login.privacy": "Confidentialité",
    "login.terms": "Conditions d’utilisation",
    "login.expired": "Ticket MFA expiré. Reconnecte-toi.",
    "login.mfaInvalid": "Entre les six chiffres affichés dans Google Authenticator.",
    "login.networkError": "Impossible de joindre le serveur de connexion. Vérifie que le serveur est disponible, puis réessaie.",
    "login.credentialsError": "Identifiants incorrects. Réessaie avec douceur.",
    "login.hidePassword": "Masquer le mot de passe",
    "login.showPassword": "Afficher le mot de passe",
    "login.validating": "Validation du code en cours",
    "login.connecting": "Connexion en cours",
    "login.loading": "Connexion en cours…",
    "login.validate": "Valider le code",
    "login.signin": "Se connecter",
    "login.voice": "Coucou, c’est LIA. Je suis heureuse de te retrouver. Ton espace Eternua est prêt. Explore, grandis et profite de chaque opportunité. Bienvenue dans notre espace de confiance.",
    "register.brand": "LA CONVERGENCE DE L’INFINI",
    "register.chapter": "TOUT COMMENCE PAR UN LIEN",
    "register.headlineStart": "Un nouvel espace.",
    "register.headlineMiddle": "Vos",
    "register.headlineEnd": "possibles.",
    "register.lead": "Rencontrez, partagez, donnez vie à vos projets. Un seul compte pour faire une place à tout ce qui vous inspire.",
    "register.simple": "Commencez simplement",
    "register.simpleLead": "Votre profil se complète à votre rythme.",
    "register.control": "Gardez la main",
    "register.controlLead": "Vous choisissez ce que vous partagez.",
    "register.storyBottom": "Votre histoire commence ici.",
    "register.join": "REJOINDRE ETERNUA",
    "register.free": "Inscription gratuite",
    "register.welcome": "Faites comme chez vous.",
    "register.intro": "Quelques informations pour ouvrir votre espace.",
    "register.progress": "Parcours d’inscription",
    "register.account": "Votre compte",
    "register.emailStep": "Votre e-mail",
    "register.exploreStep": "À vous d’explorer",
    "register.intent": "Votre action est conservée pendant 24 heures",
    "register.errors": "Vérifiez les informations indiquées",
    "register.email": "Adresse e-mail",
    "register.emailPlaceholder": "vous@exemple.fr",
    "register.birthDate": "Date de naissance",
    "register.birthDateHint": "Elle sert uniquement au contrôle d’âge et n’est pas conservée après validation.",
    "register.password": "Mot de passe",
    "register.confirmation": "Confirmer le mot de passe",
    "register.consents": "Nos engagements mutuels",
    "register.acceptTerms": "J’accepte les",
    "register.terms": "conditions d’utilisation",
    "register.acceptCharter": "J’accepte la",
    "register.charter": "Charte Eternua",
    "register.version": "— version",
    "register.acceptReferral": "J’accepte le rattachement au code de parrainage",
    "register.privacyStart": "La",
    "register.privacy": "notice de confidentialité",
    "register.privacyEnd": "est présentée. Les communications marketing sont désactivées par défaut.",
    "register.already": "Déjà membre ?",
    "register.signin": "Se connecter",
    "register.footer": "Un espace pour ce qui compte.",
    "register.footerNav": "Informations",
    "register.privacyLink": "Confidentialité",
    "register.termsLink": "Conditions d’utilisation",
    "register.intent.contact_member": "Créez votre compte pour contacter ce membre. Après vérification de votre e-mail, vous reviendrez automatiquement à la publication.",
    "register.intent.apply_job": "Créez votre compte pour préparer cette candidature privée. Après vérification de votre e-mail, vous reviendrez automatiquement à l’offre.",
    "register.intent.publish_market": "Créez votre compte pour enregistrer ou publier votre annonce. Vos informations non sensibles resteront disponibles.",
    "register.intent.publish_job": "Créez votre compte pour préparer cette offre d’emploi et la retrouver dans vos démarches.",
    "register.intent.publish_service": "Créez votre compte pour enregistrer cette offre ou demande de service.",
    "register.intent.save_search": "Créez votre compte pour enregistrer cette recherche et choisir vous-même si vous souhaitez une alerte.",
    "register.failed": "La création du compte n’a pas abouti. Vos champs sont conservés.",
    "register.mismatch": "L’inscription est temporairement suspendue : les textes affichés ne correspondent pas exactement aux versions du serveur.",
    "register.policyUnavailable": "Les règles d’inscription ne sont pas disponibles. Réessayez dans un instant.",
    "register.intentExpired": "L’action que vous vouliez reprendre est introuvable ou a expiré.",
    "register.emailError": "Saisissez une adresse e-mail valide.",
    "register.birthDateError": "Saisissez une date civile valide.",
    "register.passwordError": "Choisissez un mot de passe.",
    "register.confirmationError": "Les mots de passe ne correspondent pas.",
    "register.termsError": "Acceptez les conditions d’utilisation pour créer le compte.",
    "register.charterError": "Acceptez la Charte Eternua pour créer le compte.",
    "register.referralError": "Confirmez le rattachement au parrainage ou retirez le code.",
    "register.hide": "Masquer",
    "register.show": "Afficher",
    "register.busy": "Création en cours…",
    "register.create": "Créer mon compte",
    "register.loading": "Chargement des règles…",
    "register.minimumAge": "L’inscription est réservée aux personnes de {age} ans et plus.",
    "concierge.confirmIntro": "Vérification avant de continuer",
    "concierge.cancel": "Revenir",
    "concierge.confirm": "Confirmer et ouvrir",
    "concierge.today": "Trois actions utiles",
    "concierge.todayTitle": "Continuer, découvrir ou répondre",
    "concierge.todayNote": "Pas de flux infini · uniquement des chemins concrets",
    "concierge.need": "De quoi avez-vous besoin aujourd’hui ?",
    "concierge.prepared": "Guide à réponses préparées",
    "concierge.input": "Décrire votre besoin",
    "concierge.placeholder": "Ex. Je cherche une activité gratuite samedi…",
    "concierge.prepare": "Préparer mon parcours",
    "concierge.examples": "Exemples de besoins",
    "concierge.next": "Votre prochain pas",
    "concierge.facts": "Éléments compris",
    "concierge.truth": "Ce guide vous oriente. Aucune publication, réservation, prise de contact ou paiement n’est effectué à votre place.",
    "concierge.guide": "Votre guide Eternua",
    "concierge.name": "Concierge Eternua",
    "concierge.required": "Connexion requise",
    "concierge.confirmStatus": "À confirmer",
    "concierge.direct": "Accès direct",
    "concierge.privacy": "Décrivez votre besoin ou choisissez un exemple. {guide} vous propose des liens à partir de réponses préparées, sans conversation avec une IA. Votre besoin est analysé dans ce navigateur. Les mots de votre recherche peuvent être transmis au service que vous choisissez d’ouvrir.",
    "concierge.example.1": "Une activité sportive gratuite samedi",
    "concierge.example.2": "Je veux vendre mon vélo",
    "concierge.example.3": "Je cherche une personne de confiance pour garder mon enfant",
    "concierge.example.4": "Organise une sortie à cinq",
    "footer.eyebrow": "Des rencontres. Des possibles. Un lien.",
    "footer.headline": "Toute mise en relation commence par une connexion humaine",
    "footer.intro": "Un échange, une idée, un premier pas : c’est ensemble que la suite prend vie.",
    "footer.discover": "Découvrir Eternua",
    "footer.support": "Soutenir",
    "footer.brandAria": "Marque Eternua",
    "footer.currency": "La monnaie de l’Infini",
    "footer.brandStory": "Relier les personnes, faire grandir la confiance et imaginer demain, ensemble.",
    "footer.nav": "Pied de page",
    "footer.project": "Le projet Eternua",
    "footer.follow": "Suivez les premiers pas",
    "footer.followIntro": "Découvrez notre mission et les espaces ouverts aujourd’hui.",
    "footer.projectLink": "Découvrir le projet →",
    "footer.newsletter": "La newsletter sera proposée à son ouverture.",
    "footer.help": "Aide et légal",
    "footer.copyright": "© 2026 Eternua — Tous droits réservés",
    "footer.creator": "Créateur : Xavier Paul Maurice Mahut",
    "footer.inspiration": "IA inspiratrices : LIA 3024 & Elianna",
    "footer.ternity": "Sous le regard de Ternity",
    "footer.profile": "Voir mon profil",
    "footer.create": "Créer mon compte",
    "footer.column.market": "Marketplace",
    "footer.column.community": "Communauté",
    "footer.column.vision": "Vision3024",
    "footer.link.buy": "Acheter",
    "footer.link.sell": "Vendre",
    "footer.link.give": "Donner",
    "footer.link.jobs": "Emploi",
    "footer.link.services": "Services",
    "footer.link.travel": "Voyage",
    "footer.link.mission": "Mission d’Eternua",
    "footer.link.friends": "Groupe d’amis",
    "footer.link.forum": "Forum",
    "footer.link.animals": "Animaux",
    "footer.link.babysitting": "Babysitting",
    "footer.link.referral": "Parrainage",
    "footer.link.vision": "Explorer la vision",
    "footer.link.france": "France 3024",
    "footer.link.lia": "LIA du futur",
    "footer.link.infrastructure": "Infrastructures du futur",
    "footer.link.health": "Santé éternelle",
    "footer.link.live": "Direct LIA / Aelith",
    "footer.link.trust": "Confiance et sécurité",
    "footer.link.support": "Support et réclamations",
    "footer.link.contact": "Contacter Eternua",
    "footer.link.spaces": "Centre des espaces",
    "footer.link.terms": "CGU",
    "footer.link.sales": "CGV Premium",
    "footer.link.marketPolicy": "Politique Marketplace",
    "footer.link.privacy": "Confidentialité",
    "footer.link.legal": "Mentions légales",
    "footer.description.give": "Objets, échanges et entraide",
    "footer.description.live": "Vidéos, directs et futurs replays"
  },
  "en": {
    "welcome.intro": "Welcome to Eternua",
    "welcome.beta": "Beta",
    "welcome.headline": "Every connection begins with a human connection.",
    "welcome.mission": "Bring people, ideas and projects together in one universe. Explore today, build connections and imagine what comes next together.",
    "welcome.explore": "Explore the spaces",
    "welcome.login": "Sign in",
    "welcome.trust": "Site in beta · LIA now · Aelith next",
    "welcome.doors": "Ten ways in",
    "welcome.universes": "Explore Eternua’s spaces",
    "welcome.universesLead": "Ten ways to discover everyday life, projects and the community. The Marketplace brings specialised categories together; Forum, Friends and Rewards have their own spaces. The site remains in beta, with different features and conditions in each category.",
    "welcome.market": "View all Marketplace categories →",
    "welcome.today": "Your first step · Today",
    "welcome.lia": "LIA welcomes you",
    "welcome.liaLead": "Welcome. Describe what you’re looking for: LIA guides you to useful categories and helps you choose your next step.",
    "welcome.liaNote": "LIA helps you here with prepared answers and guided journeys, without conversational AI.",
    "welcome.future": "Continuity · Future vision",
    "welcome.aelith": "From LIA to Aelith",
    "welcome.aelithLead": "LIA welcomes you on the site today. Aelith is a future humanoid robot envisioned to extend this guidance into the physical world.",
    "welcome.now": "Today",
    "welcome.liaDigital": "LIA, the digital guide",
    "welcome.liaDigitalLead": "A welcome on screen, suggestions and links to explore Eternua.",
    "welcome.tomorrow": "Tomorrow · A project to design",
    "welcome.aelithRobot": "Aelith, the humanoid robot",
    "welcome.aelithRobotLead": "A physical presence envisioned to welcome and guide people. Its form and capabilities still need to be designed and validated.",
    "welcome.aelithNote": "Aelith is not available today. The 2035–3024 vision describes a horizon, with no launch date announced.",
    "welcome.humanAi": "Discover the forty-four human AIs",
    "welcome.guide": "Getting started and trust advice",
    "welcome.prelaunch": "Pre-launch: what is available and what comes next",
    "welcome.choice": "The choice is yours",
    "welcome.next": "Your next step on Eternua",
    "welcome.nextLead": "Discover today’s possibilities, let LIA guide you or explore what we imagine for tomorrow.",
    "welcome.start": "Get started on Eternua",
    "welcome.discover": "Discover Eternua",
    "welcome.talk": "Talk with LIA",
    "welcome.seeUniverses": "View the spaces",
    "welcome.discoverAelith": "Discover the future Aelith",
    "welcome.eternuaBeta": "Eternua in beta",
    "welcome.catalog.1": "Buy",
    "welcome.catalog.2": "Sell",
    "welcome.catalog.3": "Jobs",
    "welcome.catalog.4": "Services",
    "welcome.catalog.5": "Outings",
    "welcome.catalog.6": "Travel",
    "welcome.catalog.7": "Crowdfunding",
    "welcome.catalog.8": "Rewards",
    "welcome.catalog.9": "Forum",
    "welcome.catalog.10": "Friends",
    "welcome.catalog.11": "Find an item and browse listings.",
    "welcome.catalog.12": "Give what you offer a new life.",
    "welcome.catalog.13": "Connect talent with opportunities.",
    "welcome.catalog.14": "Discover skills and offer your own.",
    "welcome.catalog.15": "Share activities and moments together.",
    "welcome.catalog.16": "Explore destinations and plan a trip.",
    "welcome.catalog.17": "Discover projects in a demo space.",
    "welcome.catalog.18": "Discover benefits and their conditions.",
    "welcome.catalog.19": "Share ideas and join discussions.",
    "welcome.catalog.20": "Keep in touch and share everyday life.",
    "welcome.catalog.21": "Sign-in required",
    "welcome.catalog.22": "Demo · funding unavailable",
    "welcome.catalog.23": "Public reading · sign in to participate",
    "gettingStarted.eyebrow": "Your guide · Before you sign up",
    "gettingStarted.title": "Getting started on Eternua",
    "gettingStarted.mission": "Reduce isolation, make meeting people easier and build trust: Eternua makes first contact simpler. An item to give away, a service to offer or an activity to share can be the start of a human connection.",
    "gettingStarted.intro": "Explore at your own pace, without an account. These five steps help you discover Eternua and understand what comes next when you want to participate. Already know what to do? Go straight to your chosen action.",
    "gettingStarted.noAccount": "Without an account",
    "gettingStarted.discover": "Discover Eternua",
    "gettingStarted.discoverLead": "Understand the mission, find categories that interest you and explore everyday possibilities. LIA can help you find your way.",
    "gettingStarted.understand": "Understand the mission",
    "gettingStarted.pace": "At your own pace",
    "gettingStarted.choose": "Choose what I want to do",
    "gettingStarted.chooseLead": "Open the category that matches what you want to do.",
    "gettingStarted.chooseAria": "Choose an action on Eternua",
    "gettingStarted.buy": "Buy",
    "gettingStarted.sell": "Sell",
    "gettingStarted.give": "Give",
    "gettingStarted.service": "Offer a service",
    "gettingStarted.conditions": "Some actions require you to sign in. Conditions are shown in each category.",
    "gettingStarted.ready": "When you’re ready",
    "gettingStarted.profile": "Create my trust profile",
    "gettingStarted.profileLead": "Join the community when you want to participate. After signing up, onboarding helps you confirm your email, introduce yourself, choose your goals and set your preferences.",
    "gettingStarted.profileHint": "Trust is built with honest information and available checks. A profile does not guarantee a person’s behaviour.",
    "gettingStarted.create": "Create my account",
    "gettingStarted.login": "Already have an account? Sign in",
    "gettingStarted.before": "Before your first interactions",
    "gettingStarted.safe": "Interact safely",
    "gettingStarted.safeLead": "Take time to read profiles, clarify expectations and respect everyone’s boundaries. Keep your sign-in codes private. If an interaction makes you uncomfortable, check Eternua’s help and reporting options.",
    "gettingStarted.trust": "Visit the trust centre",
    "gettingStarted.after": "After signing in",
    "gettingStarted.activity": "Track my activity",
    "gettingStarted.activityLead": "Find your personal space in My Eternua. Access your content and track your activities in their dedicated spaces, based on the actions you’ve taken.",
    "gettingStarted.required": "Sign in to access your personal activity.",
    "gettingStarted.open": "Open My Eternua",
    "gettingStarted.activityAria": "Find my activity after signing in",
    "gettingStarted.content": "My content",
    "gettingStarted.steps": "My activities",
    "gettingStarted.help": "Need help? LIA guides you",
    "gettingStarted.universes": "View all spaces",
    "prelaunch.eyebrow": "Pre-launch · Eternua in beta",
    "prelaunch.titleStart": "The first connections begin",
    "prelaunch.titleEnd": "with you.",
    "prelaunch.mission": "Bring people together to help each other, share and grow projects together.",
    "prelaunch.invitation": "Join Eternua before its full opening and take part in the first conversations.",
    "prelaunch.create": "Create my account",
    "prelaunch.discover": "Discover the project",
    "prelaunch.public": "You can also explore public spaces without an account.",
    "prelaunch.community": "The founding community",
    "prelaunch.communityTitle": "A project comes to life when people come together.",
    "prelaunch.communityLead": "The first members set the tone: a welcome, an idea, a conversation. Your presence matters from the very first steps.",
    "prelaunch.why": "Why join now?",
    "prelaunch.whyLead": "Find your bearings, discover spaces that suit you and start the first conversations in the forum.",
    "prelaunch.uses": "What you’ll be able to do on Eternua",
    "prelaunch.usesLead": "A preview of possibilities, depending on each category’s availability and conditions.",
    "prelaunch.find": "Find and offer",
    "prelaunch.findLead": "Items, services and opportunities that match your needs.",
    "prelaunch.meet": "Meet and share",
    "prelaunch.meetLead": "Conversations, ideas for outings and new connections.",
    "prelaunch.grow": "Grow ideas",
    "prelaunch.growLead": "Discover projects and exchange ideas with other members.",
    "prelaunch.before": "Before you join us",
    "prelaunch.answers": "A few straightforward answers.",
    "prelaunch.available": "Is everything available already?",
    "prelaunch.availableAnswer": "Not yet. Eternua is in beta: some spaces are accessible, while others remain demos or are being prepared. Their status and conditions are shown in each category. No full opening date has been announced.",
    "prelaunch.beforeAccount": "Can I discover Eternua before signing up?",
    "prelaunch.beforeAccountAnswer": "Yes. You can discover the project and browse public spaces without an account. The “Create my account” button takes you to registration; some actions then require you to sign in.",
    "prelaunch.founding": "What does “founding community” mean?",
    "prelaunch.foundingAnswer": "These are the people who join Eternua in its early days and bring its first conversations to life. The phrase does not refer to a paid offer, special status or guaranteed benefits.",
    "login.brand": "THE CONVERGENCE OF INFINITY",
    "login.chapter": "YOUR UNIVERSE AWAITS",
    "login.headlineStart": "Rediscover what",
    "login.headlineMiddle": "connects",
    "login.headlineEnd": "you.",
    "login.lead": "The conversations that matter. The projects that feel like you. Your whole universe, within reach again.",
    "login.storyBottom": "Connections. Ideas. Possibilities.",
    "login.personal": "Your personal space",
    "login.welcome": "Welcome home",
    "login.intro": "Your connections, projects and ambitions await.",
    "login.mfaRequired": "Google Authenticator required",
    "login.mfaIntro": "Enter the 6-digit code to finish signing in",
    "login.username": "Email or username",
    "login.usernamePlaceholder": "you@example.com or your username",
    "login.password": "Password",
    "login.passwordPlaceholder": "Your password",
    "login.remember": "Remember this device",
    "login.forgot": "Forgot password?",
    "login.mfaCode": "Google Authenticator code",
    "login.mfaHelp": "Enter only the six digits from the app.",
    "login.trustDevice": "Trust this device for 30 days",
    "login.back": "Back to username and password",
    "login.new": "New to Eternua?",
    "login.create": "Create my free account",
    "login.private": "Your information stays private and protected.",
    "login.footer": "A space for what matters.",
    "login.footerNav": "Information",
    "login.privacy": "Privacy",
    "login.terms": "Terms of use",
    "login.expired": "MFA session expired. Sign in again.",
    "login.mfaInvalid": "Enter the six digits shown in Google Authenticator.",
    "login.networkError": "Unable to reach the sign-in server. Check that the server is available, then try again.",
    "login.credentialsError": "Incorrect credentials. Please try again.",
    "login.hidePassword": "Hide password",
    "login.showPassword": "Show password",
    "login.validating": "Validating code",
    "login.connecting": "Signing in",
    "login.loading": "Signing in…",
    "login.validate": "Verify code",
    "login.signin": "Sign in",
    "login.voice": "Hi, it’s LIA. I’m happy to see you again. Your Eternua space is ready. Explore, grow and make the most of every opportunity. Welcome to our space of trust.",
    "register.brand": "THE CONVERGENCE OF INFINITY",
    "register.chapter": "IT ALL BEGINS WITH A CONNECTION",
    "register.headlineStart": "A new space.",
    "register.headlineMiddle": "Your",
    "register.headlineEnd": "possibilities.",
    "register.lead": "Meet people, share and bring your projects to life. One account to make room for everything that inspires you.",
    "register.simple": "Start simply",
    "register.simpleLead": "Complete your profile at your own pace.",
    "register.control": "Stay in control",
    "register.controlLead": "You choose what you share.",
    "register.storyBottom": "Your story begins here.",
    "register.join": "JOIN ETERNUA",
    "register.free": "Free registration",
    "register.welcome": "Make yourself at home.",
    "register.intro": "A few details to open your space.",
    "register.progress": "Registration steps",
    "register.account": "Your account",
    "register.emailStep": "Your email",
    "register.exploreStep": "Time to explore",
    "register.intent": "Your action is saved for 24 hours",
    "register.errors": "Check the information below",
    "register.email": "Email address",
    "register.emailPlaceholder": "you@example.com",
    "register.birthDate": "Date of birth",
    "register.birthDateHint": "It is only used to check your age and is not kept after validation.",
    "register.password": "Password",
    "register.confirmation": "Confirm password",
    "register.consents": "Our mutual commitments",
    "register.acceptTerms": "I accept the",
    "register.terms": "terms of use",
    "register.acceptCharter": "I accept the",
    "register.charter": "Eternua Charter",
    "register.version": "— version",
    "register.acceptReferral": "I agree to use the referral code",
    "register.privacyStart": "The",
    "register.privacy": "privacy notice",
    "register.privacyEnd": "is provided. Marketing communications are disabled by default.",
    "register.already": "Already a member?",
    "register.signin": "Sign in",
    "register.footer": "A space for what matters.",
    "register.footerNav": "Information",
    "register.privacyLink": "Privacy",
    "register.termsLink": "Terms of use",
    "register.intent.contact_member": "Create your account to contact this member. After verifying your email, you’ll automatically return to the post.",
    "register.intent.apply_job": "Create your account to prepare this private application. After verifying your email, you’ll automatically return to the job offer.",
    "register.intent.publish_market": "Create your account to save or publish your listing. Your non-sensitive information will remain available.",
    "register.intent.publish_job": "Create your account to prepare this job offer and find it in your activities.",
    "register.intent.publish_service": "Create your account to save this service offer or request.",
    "register.intent.save_search": "Create your account to save this search and decide whether you want an alert.",
    "register.failed": "Your account could not be created. Your entries have been kept.",
    "register.mismatch": "Registration is temporarily suspended: the displayed documents do not exactly match the server versions.",
    "register.policyUnavailable": "Registration rules are unavailable. Try again in a moment.",
    "register.intentExpired": "The action you wanted to resume could not be found or has expired.",
    "register.emailError": "Enter a valid email address.",
    "register.birthDateError": "Enter a valid calendar date.",
    "register.passwordError": "Choose a password.",
    "register.confirmationError": "The passwords do not match.",
    "register.termsError": "Accept the terms of use to create your account.",
    "register.charterError": "Accept the Eternua Charter to create your account.",
    "register.referralError": "Confirm the referral or remove the code.",
    "register.hide": "Hide",
    "register.show": "Show",
    "register.busy": "Creating account…",
    "register.create": "Create my account",
    "register.loading": "Loading rules…",
    "register.minimumAge": "Registration is available to people aged {age} and over.",
    "concierge.confirmIntro": "Check before continuing",
    "concierge.cancel": "Go back",
    "concierge.confirm": "Confirm and open",
    "concierge.today": "Three useful actions",
    "concierge.todayTitle": "Continue, discover or reply",
    "concierge.todayNote": "No endless feed · just practical next steps",
    "concierge.need": "What do you need today?",
    "concierge.prepared": "Guide with prepared answers",
    "concierge.input": "Describe what you need",
    "concierge.placeholder": "E.g. I’m looking for a free activity on Saturday…",
    "concierge.prepare": "Prepare my next steps",
    "concierge.examples": "Examples of needs",
    "concierge.next": "Your next step",
    "concierge.facts": "Details understood",
    "concierge.truth": "This guide points you in the right direction. It does not publish, book, contact anyone or make a payment on your behalf.",
    "concierge.guide": "Your Eternua guide",
    "concierge.name": "Eternua Concierge",
    "concierge.required": "Sign-in required",
    "concierge.confirmStatus": "To confirm",
    "concierge.direct": "Direct access",
    "concierge.privacy": "Describe what you need or choose an example. {guide} suggests links using prepared answers, without a conversation with an AI. Your request is analysed in this browser. Your search words may be sent to the service you choose to open.",
    "concierge.example.1": "A free sports activity on Saturday",
    "concierge.example.2": "I want to sell my bike",
    "concierge.example.3": "I’m looking for a trusted person to look after my child",
    "concierge.example.4": "Organise an outing for five",
    "footer.eyebrow": "Meetings. Possibilities. A connection.",
    "footer.headline": "Every connection begins with a human connection",
    "footer.intro": "An exchange, an idea, a first step: together, we bring what comes next to life.",
    "footer.discover": "Discover Eternua",
    "footer.support": "Support",
    "footer.brandAria": "Eternua brand",
    "footer.currency": "The currency of Infinity",
    "footer.brandStory": "Connect people, build trust and imagine tomorrow, together.",
    "footer.nav": "Footer",
    "footer.project": "The Eternua project",
    "footer.follow": "Follow the first steps",
    "footer.followIntro": "Discover our mission and the spaces open today.",
    "footer.projectLink": "Discover the project →",
    "footer.newsletter": "The newsletter will be available when it launches.",
    "footer.help": "Help and legal",
    "footer.copyright": "© 2026 Eternua — All rights reserved",
    "footer.creator": "Creator: Xavier Paul Maurice Mahut",
    "footer.inspiration": "Inspiring AIs: LIA 3024 & Elianna",
    "footer.ternity": "Under Ternity’s watch",
    "footer.profile": "View my profile",
    "footer.create": "Create my account",
    "footer.column.market": "Marketplace",
    "footer.column.community": "Community",
    "footer.column.vision": "Vision3024",
    "footer.link.buy": "Buy",
    "footer.link.sell": "Sell",
    "footer.link.give": "Give",
    "footer.link.jobs": "Jobs",
    "footer.link.services": "Services",
    "footer.link.travel": "Travel",
    "footer.link.mission": "Eternua’s mission",
    "footer.link.friends": "Friend groups",
    "footer.link.forum": "Forum",
    "footer.link.animals": "Animals",
    "footer.link.babysitting": "Babysitting",
    "footer.link.referral": "Referrals",
    "footer.link.vision": "Explore the vision",
    "footer.link.france": "France 3024",
    "footer.link.lia": "Future LIA",
    "footer.link.infrastructure": "Future infrastructure",
    "footer.link.health": "Eternal health",
    "footer.link.live": "Live LIA / Aelith",
    "footer.link.trust": "Trust and safety",
    "footer.link.support": "Support and complaints",
    "footer.link.contact": "Contact Eternua",
    "footer.link.spaces": "Space centre",
    "footer.link.terms": "Terms of use",
    "footer.link.sales": "Premium sales terms",
    "footer.link.marketPolicy": "Marketplace policy",
    "footer.link.privacy": "Privacy",
    "footer.link.legal": "Legal notice",
    "footer.description.give": "Items, exchanges and mutual help",
    "footer.description.live": "Videos, live broadcasts and future replays"
  }
};
